import React, { Component } from 'react'
import compose from 'recompose/compose'
import translate from '@/i18n/translate'
import { reduxForm, Field, change, getFormValues } from 'redux-form' // eslint-disable-line
import { Card } from '@/ui/Card'
import { InputField } from '@/ui/Input'
import { CheckBox } from '@/ui/Input'
import { DatePicker } from '@/ui/DatePicker'
import AutoComplete from '@/ui/Data/AutoCompleteField'
import { Flex } from '@/ui/Element'
import Button from '@/ui/Button/Button'

const required = value => {
  return value ? undefined : 'Required'
}

class setupNewsletter extends Component {
  render() {
    const { theme, handleSubmit, runSubmit, formRef, goBack, submitting, onChange } = this.props // eslint-disable-line

    return (
      <form className="form" onSubmit={handleSubmit(runSubmit)}>
        <Card classes={['t-padding-large', 'colored-card']}>
          <div className={theme['card-content']}>
            <label>Company location:</label>
            <div className={`${theme['flex']} ${theme['flex-row']} ${theme['bottom-margin']}`}>
              <label className={theme['right-margin']}>
                <Field name="location" component={'input'} type="radio" value="de" />Germany
              </label>
              <label>
                <Field name="location" component={'input'} type="radio" value="ch" />Switzerland
              </label>
            </div>
            <Field
              name="title"
              labelText="Newsletter title:"
              component={InputField}
              placeholder="Title"
              id="title"
              validate={[required]}
            />
            <Field
              name="product_id"
              labelText="Product:"
              titleProperty="title"
              src="products"
              component={AutoComplete}
              placeholder="Product"
              id="product_id"
              validate={[required]}
            />
            <Field
              name="contact_id"
              labelText="Contact person:"
              titleProperty="full_name"
              src="contacts"
              filter={c => c.disabled}
              component={AutoComplete}
              sort={true}
              placeholder="Contact person"
              id="contact_id"
              validate={[required]}
            />
            <Field
              name="scheduled_at"
              labelText="Scheduled date:"
              component={DatePicker}
              closeOnSelect={true}
              placeholder="DD-MM-YYYY"
              id="scheduled_at"
              validate={[required]}
            />
            <Field
              name="status"
              labelText="Completed:"
              component={CheckBox}
              theme={theme}
              id="status"
              values={{ processed: true, 'in-progress': false }}
            />
          </div>
        </Card>
        <Flex horz="right" classes={['top-margin-24']}>
          <Button theme={theme} styles="right-margin" disabled={submitting} onClick={goBack}>
            Cancel
          </Button>
          <Button
            theme={theme}
            type="submit"
            classes={['secondary']}
            styles="h-padding-large"
            disabled={submitting}
            getRef={formRef}
          >
            Continue
          </Button>
        </Flex>
      </form>
    )
  }
}

const enhance = compose(
  translate,
  reduxForm({
    enableReinitialize: true,
    form: 'setupNewsletter',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      ;['title', 'product_id', 'contact_id', 'scheduled_at'].forEach(field => {
        if (!values[field]) errors[field] = translate('i18n.validation.required')
      })
      return errors
    },
  }),
)

export default enhance(setupNewsletter)



// WEBPACK FOOTER //
// ./view/Dashboard/setupNewsletter.js